<template>
  <div class="quotationInformation">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <div class="title" v-if="BJId">{{ $t.onlineOrder.editTitle3 }}</div>
      <div class="title" v-else>{{ $t.onlineOrder.addTitle3 }}</div>

      <van-field
        v-model="form.BJNumber"
        :label="$t.onlineOrder.bjNumber"
        label-class="number-label"
        readonly
        v-if="BJId"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(form.BJNumber)"
            native-type="button"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="form.UpdateTime"
        :label="$t.onlineOrder.updateTime"
        readonly
        v-if="BJId"
      />

      <van-field
        v-model="form.ShippingProductName"
        :label="$t.onlineOrder.shippingProductName"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.WMIdStr"
        :label="$t.onlineOrder.warehouseGoods"
        @click="pickerShow(0, 'showQuotationInformationWarehouse')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        required
      />

      <van-field :label="$t.onlineOrder.companyIcon">
        <template #input>
          <van-uploader v-model="companyIcon" :max-count="1" :after-read="afterRead1" />
        </template>
      </van-field>

      <div class="quotationInformation-checkbox">
        <div class="checkbox-label">{{ $t.onlineOrder.attribute }}</div>
        <van-checkbox v-model="form.Liquid">{{ $t.onlineOrder.liquid }}</van-checkbox>
        <van-checkbox v-model="form.Powder">{{ $t.onlineOrder.powder }}</van-checkbox>
        <van-checkbox v-model="form.Paste">{{ $t.onlineOrder.paste }}</van-checkbox>
        <van-checkbox v-model="form.Charged">{{ $t.onlineOrder.charged }}</van-checkbox>
        <van-checkbox v-model="form.Magnetic">{{ $t.onlineOrder.magnetic }}</van-checkbox>
        <van-checkbox v-model="form.DontBelong">{{
          $t.onlineOrder.unlimited
        }}</van-checkbox>
      </div>

      <div class="multi-table" v-if="form.qfList">
        <van-field name="stepper" :label="$t.onlineOrder.stepper1">
          <template #input>
            <van-stepper
              :min="1"
              :value="form.qfList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.qfList" :key="index">
          <div class="multi-table-header" v-if="index > 0">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>

          <van-field
            v-model="item.CountryName"
            :label="$t.onlineOrder.arrivalCountry"
            @click="onShowEmit(index, 'showQuotationInformationCountry')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            required
          />

          <van-field
            v-model="item.FirstWeightPrice"
            :label="$t.onlineOrder.firstEachWeight + '(USD)'"
            :placeholder="$t.meta.input"
            required
            :rules="formRule"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />

          <van-field
            v-model="item.FirstWeight"
            :label="$t.onlineOrder.firstWeight"
            :placeholder="$t.meta.input"
            required
            :rules="formRule"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />

          <van-field
            v-model="item.ContinuousWeightPrice"
            :label="$t.onlineOrder.continueWeightPrice"
            :placeholder="$t.meta.input"
            required
            :rules="formRule"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />

          <van-field
            v-model="item.ContinuousWeight"
            :label="$t.onlineOrder.continueWeight"
            :placeholder="$t.meta.input"
            required
            :rules="formRule"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />

          <van-field
            v-model="item.ArriveDay"
            :label="$t.onlineOrder.arriveDay"
            :placeholder="$t.meta.input"
            required
            :rules="formRule"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showQuotationInformationWarehouse" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.warehouseGoods"
        show-toolbar
        :columns="warehouseList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="warehouseConfirm($event)"
        @cancel="showQuotationInformationWarehouse = false"
      />
    </van-popup>

    <option-list
      event="showQuotationInformationCountry"
      :options="countryList"
      @onSelect="countryConfirm"
    ></option-list>
  </div>
</template>
<script>
import OptionList from "@components/optionList/OptionList.vue";
import Vue from "vue";
import {
  Form,
  Field,
  Checkbox,
  Button,
  Icon,
  Image,
  Uploader,
  Picker,
  Popup,
  Stepper,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Checkbox)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Uploader)
  .use(Picker)
  .use(Popup)
  .use(Stepper);

export default {
  name: "quotationInformation",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      BJId: "",
      form: {
        BJId: "",
        AccountNickName: "",
        ShippingProductName: "",
        WMIdStr: "",
        WMId: "",
        CompanyIcon: "",
        Liquid: 0,
        Powder: 0,
        Paste: 0,
        Charged: 0,
        Magnetic: 0,
        DontBelong: 0,
        qfList: [
          {
            CountryName: "",
            CountryCode: "",
            FirstWeightPrice: "",
            FirstWeight: "",
            ContinuousWeightPrice: "",
            ContinuousWeight: "",
            ArriveDay: "",
          },
        ],
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      companyIcon: [],
      //picker
      warehouseList: [],
      showQuotationInformationWarehouse: false,
      countryList: [],
      showQuotationInformationCountry: false,
      itemIndex: 0,
    };
  },
  created() {
    const { BJId } = this.$route.query;
    if (BJId) {
      this.BJId = BJId;
      this.getOptions().then((success) => {
        if (success) {
          this.loadQuotationInfo();
        }
      });
    } else {
      this.getOptions();
    }
  },
  methods: {
    handleDelByIndex(index) {
      if (this.form.qfList.length > 0) {
        this.form.qfList.splice(index, 1);
      }
    },
    handleDel() {
      if (this.form.qfList.length > 0) {
        this.form.qfList.pop();
      }
    },
    handleAdd() {
      this.form.qfList.push({
        CountryName: "",
        CountryCode: "",
        FirstWeightPrice: "",
        FirstWeight: "",
        ContinuousWeightPrice: "",
        ContinuousWeight: "",
        ArriveDay: "",
      });
    },
    warehouseConfirm(e) {
      this.form.WMIdStr = e.text;
      this.form.WMId = e.value;
      this.showQuotationInformationWarehouse = false;
    },
    countryConfirm(e) {
      this.form.qfList[this.itemIndex].CountryName = e.text;
      this.form.qfList[this.itemIndex].CountryCode = e.value;
      this.showQuotationInformationCountry = false;
      this.$forceUpdate();
    },
    pickerShow(index, pickerName) {
      this[pickerName] = true;
      this.itemIndex = index;
      this.$forceUpdate();
    },
    onShowEmit(index, emit) {
      this.itemIndex = index;
      this.$bus.$emit(emit, true);
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getVCByCountrysList(), this.getWarehouseInfoList()])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getVCByCountrysList() {
      return new Promise((resolve) => {
        this.$api.onlineOrderManagement
          .getVCByCountrysList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text:
                  item.CountryEnglishName + "," + item.CountryA2 + "," + item.CountryA3,
                value: item.CountryA2,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getWarehouseInfoList() {
      return new Promise((resolve) => {
        var param = {
          CompanyId: this.CompanyId,
          WarehouseState: 1,
          PageIndex: 1,
          PageSize: 999,
        };
        this.$api.onlineOrderManagement
          .getWarehouseInfoList(param)
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.WarehouseNameSn + " , " + item.WarehouseCode,
                value: item.WMId,
              };
              result.push(data);
            });
            this.warehouseList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    loadQuotationInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          BJId: this.BJId,
        };
        this.$api.onlineOrderManagement
          .loadQuotationInfo(param)
          .then((res) => {
            this.form = res.data;
            //图标
            if (this.form.CompanyIcon) {
              this.companyIcon.push({
                url: this.imgUrlFilter(this.form.CompanyIcon),
              });
            }
            //集货仓库
            var warehouse = this.warehouseList.find((c) => c.value == this.form.WMId);
            if (warehouse) {
              this.form.WMIdStr = warehouse.text;
              this.form.WMId = warehouse.value;
            }
            //送抵国家地区
            for (var item of this.form.qfList) {
              if (item.CountryCode) {
                var country = this.countryList.find((c) => c.value == item.CountryCode);
                if (country) {
                  item.CountryName = country.text;
                }
              }
            }
            this.$commonMethod.fieldRefresh(".quotationInformation");
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      var request = null;
      if (this.BJId) {
        for (var i in param.qfList) {
          param.qfList[i].BJId = this.BJId;
        }
        param.UpdateUserId = this.UserId;
        request = this.$api.onlineOrderManagement.editQuotationInfo(param);
      } else {
        param.CreateUserId = this.UserId;
        request = this.$api.onlineOrderManagement.addQuotationInfo(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.CompanyIcon = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.quotationInformation {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .avatarImg {
    width: 50px;
    height: 50px;
  }
  .quotationInformation-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
      display: inline-flex;
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
}
</style>
